export default {
      id: "reefer-info-2-usage",
      viewBox: "0 0 34 30",
      url: __webpack_public_path__ + "img/icons.svg#reefer-info-2",
      toString: function () {
        return this.url;
      }
    }